'use client';

import type { FC, ReactNode } from 'react';
import { cn } from '../../utils/cn';

interface OverlayBadgeProps {
  children: ReactNode;
  className?: string;
}

export const OverlayBadge: FC<OverlayBadgeProps> = ({ children, className }) => (
  <div className={cn('inline-flex items-center px-2 py-0.5 bg-black/70 rounded-full', className)}>
    {children}
  </div>
);
